import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as materiasService from '../../services/materias/materiasService';
import {
  classifyMateriasError,
  toUpdateMateriaPayload,
  validateMateriaForm
} from '../../services/materias/materiasDto';
import Select from '../common/AppSelect';
import { findSelectOptionByValue, YES_NO_OPTIONS } from '../../services/selectOptions';
import { LookupCarreras } from '../Carreras/LookupCarreras';

const optionsCuatrimestre = [
  { value: '1', label: 'Primer cuatrimestre' },
  { value: '2', label: 'Segundo cuatrimestre' },
  { value: 'A', label: 'Anual' },
];

const options = YES_NO_OPTIONS;

export class UpdateMateria extends Component {
  static displayName = UpdateMateria.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: "",
      name: "",
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: "",
      details: this.props.match.params.details,
      carrera: { carreraCod: 0, carreraNombre: "" },
      code: "",
      formato: "",
      anioDictado: "",
      dictado: "",
      practica: "",
      valueDictado: null,
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleAnioChangeInput = this.handleAnioChangeInput.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handleCodeChangeInput = this.handleCodeChangeInput.bind(this);
    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleFormatoChangeInput = this.handleFormatoChangeInput.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWMaterias');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.state.details === "1") {
      this.setState({ success: true })
    } else {
      if (this.isOkToSave()) {
        this.saveStudent();
      } else {
        this.setState({ showErrorMessage: true, errorMessage: "Los campos Alumno y Carrera son obligatorios" });
      }
    }
  }

  handleAnioChangeInput = e => {
    this.setState({ anioDictado: e.target.value });
  }

  handleNameChangeInput = e => {
    this.setState({ name: e.target.value });
  }

  handleCodeChangeInput = e => {
    this.setState({ code: e.target.value });
  }

  handleHideLookup = () =>
  {
    this.setState({showLookupCarreras:false});
  }

  handleShowStudentLookup = () => {
    this.setState({ showLookupStudent: true });
  }

  handleShowCarreraLookup = () => {
    this.setState({ showLookupCarreras: true });
  }

  handleSelect = e => {
    this.setState({ practica: e.value, valuePractica: e });
  }

  handleDictadoChangeInput = e => {
    this.setState({ dictado: e.value, valueDictado: e });
  }

  handleFormatoChangeInput = e => {
    this.setState({ formato: e.target.value });
  }

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.setState(
      {
        alumno: {
          alumnoDni: studentProperties[0],
          alumnoNombre: studentProperties[1],
          alumnoCodigo: parseInt(studentProperties[2])
        },
        showLookupStudent: false
      });
  }

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupCarreras: false,
      carrera: {
        carreraCod: parseInt(carreraProperties[0]),
        carreraNombre: carreraProperties[1]
      }
    });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-mxc" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de la Materia' : 'Modificar Materia';
    const { loading } = this.state;

    const dictadoLabel = this.state.valueDictado?.value === '1'
      ? 'Primer Cuatrimestre'
      : this.state.valueDictado?.value === '2'
        ? 'Segundo Cuatrimestre'
        : 'Anual';

    return (
      <div className="md-page md-update-materia">
        <Link className="md-page__back-link" to="/md-mxc">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la materia.'
            : 'Actualice los datos de la materia y guarde los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-codigo">
              Código Materia
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="materia-codigo">{this.state.code}</div>
            ) : (
              <input
                id="materia-codigo"
                className="md-page__field-input"
                name="code"
                placeholder="Ingrese Código"
                value={this.state.code}
                onChange={this.handleCodeChangeInput}
                disabled={loading}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-nombre">
              Nombre Materia
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="materia-nombre">{this.state.name}</div>
            ) : (
              <input
                id="materia-nombre"
                className="md-page__field-input"
                name="name"
                placeholder="Ingrese Nombre"
                onChange={this.handleNameChangeInput}
                disabled={loading}
                value={this.state.name}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-anio">
              Año Dictado
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="materia-anio">{this.state.anioDictado}</div>
            ) : (
              <input
                id="materia-anio"
                className="md-page__field-input"
                name="anioDictado"
                placeholder="Ingrese Año"
                onChange={this.handleAnioChangeInput}
                disabled={loading}
                value={this.state.anioDictado}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-formato">
              Formato de la Materia
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="materia-formato">{this.state.formato}</div>
            ) : (
              <input
                id="materia-formato"
                className="md-page__field-input"
                name="formato"
                placeholder="Ingrese Formato"
                onChange={this.handleFormatoChangeInput}
                disabled={loading}
                value={this.state.formato}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de Dictado</span>
            {isDetail ? (
              <div className="md-page__field-readonly">{dictadoLabel}</div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.valueDictado}
                options={optionsCuatrimestre}
                onChange={this.handleDictadoChangeInput}
                disabled={loading}
              />
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Carrera</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar carrera
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.carrera.carreraNombre}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Materia Práctica</span>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.practica === 'N' ? 'No' : 'Si'}</div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.valuePractica}
                options={options}
                onChange={this.handleSelect}
                disabled={loading}
              />
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupCarreras ? (
          <LookupCarreras selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return validateMateriaForm({
      code: this.state.code,
      name: this.state.name,
      anioDictado: this.state.anioDictado,
      dictado: this.state.dictado,
      practica: this.state.practica,
      carreraPresent: this.state.carrera.carreraNombre.length > 0
    });
  }

  async populateData() {
    try {
      const returnModel = await materiasService.getMateria(this.state.id);
      const defaultValuePractica = findSelectOptionByValue(options, returnModel.materiaPractica);
      const defaultValueAnioDictado = findSelectOptionByValue(optionsCuatrimestre, returnModel.materiaCarreraDictado);
      this.setState({
        errorMessage: "",
        carrera: {
          carreraNombre: returnModel.carreraNombre.trim(),
          carreraCodigo: returnModel.carreraCod
        },
        code: returnModel.materiaCarreraCodigo,
        name: returnModel.materiaCarreraNombre.trim(),
        anioDictado: returnModel.materiaCarreraAnio.trim(),
        dictado: returnModel.materiaCarreraDictado,
        practica: returnModel.materiaPractica,
        valuePractica: defaultValuePractica,
        valueDictado: defaultValueAnioDictado,
        formato: returnModel.materiaFormato
      });
    } catch (error) {
      const outcome = classifyMateriasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ errorMessage });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await materiasService.saveMateria(
        toUpdateMateriaPayload({
          id: this.state.id,
          code: this.state.code,
          name: this.state.name,
          dictado: this.state.dictado,
          anioDictado: this.state.anioDictado,
          practica: this.state.practica,
          carreraCod: this.state.carrera.carreraCodigo,
          formato: this.state.formato
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyMateriasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
